import { Component, EventEmitter, Output, signal, ViewEncapsulation } from '@angular/core';

import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MDIconComponent } from '@melodic-ui/components';

@Component({
	selector: 'lb-chat-message-input',
	standalone: true,
	imports: [ReactiveFormsModule, MDIconComponent],
	templateUrl: './chat-message-input.component.html',
	styleUrl: './chat-message-input.component.scss',
	encapsulation: ViewEncapsulation.None
})
export class ChatMessageInputComponent {
	@Output() messageSent = new EventEmitter<string>();

	messageControl = new FormControl<string>('');
	isSending = signal<boolean>(false);

	sendMessage(): void {
		const message = this.messageControl.value?.trim();
		if (!message || this.isSending()) return;

		this.isSending.set(true);
		this.messageSent.emit(message);
		this.messageControl.setValue('');
		this.isSending.set(false);
	}

	onKeyDown(event: KeyboardEvent): void {
		if (event.key === 'Enter' && !event.shiftKey) {
			event.preventDefault();
			this.sendMessage();
		}
	}
}
